<template>
    <div class="space-y-6">
        <div class="flex items-center gap-4">
            <span class="text-content-md font-medium text-content-secondary">Size:</span>
            <DsRadio
                v-model="size"
                label="Medium (default)"
                name="textarea-size"
                value="md"
            />
            <DsRadio
                v-model="size"
                label="Small"
                name="textarea-size"
                value="sm"
            />
        </div>

        <div class="grid grid-cols-2 gap-4">
            <div class="grid grid-cols-2 gap-4">
                <DsTextarea
                    v-model="basicValue"
                    label="Textarea"
                    :size
                />

                <DsTextarea
                    v-model="helperTextValue"
                    helperText="With helper text"
                    label="Textarea"
                    :size
                />

                <DsTextarea
                    v-model="requiredValue"
                    helperText="Required"
                    label="Textarea"
                    labelTooltip="Info icon tooltip"
                    required
                    :size
                />

                <DsTextarea
                    v-model="infoIconValue"
                    helperText="With info icon"
                    label="Textarea"
                    labelTooltip="Info icon tooltip"
                    :size
                />

                <DsTextarea
                    v-model="customRowsValue"
                    label="With custom rows"
                    :rows="2"
                    :size
                />

                <DsTextarea
                    v-model="nonResizableValue"
                    label="Non-resizable"
                    :resizable="false"
                    :size
                />

                <DsTextarea
                    v-model="errorValue"
                    error="Error message"
                    label="Textarea"
                    :size
                />
                <DsTextarea
                    v-model="errorWithoutMessageValue"
                    :error="true"
                    label="Textarea"
                    :size
                >
                    <template #error>A slotted error message</template>
                </DsTextarea>

                <DsTextarea
                    v-model="characterLimitValue"
                    label="With character limit"
                    labelTooltip="Info icon tooltip"
                    :maxlength="50"
                    required
                    :size
                />
                <DsTextarea
                    v-model="nonResizableCharacterLimitValue"
                    label="With character limit, non-resizable"
                    labelTooltip="Info icon tooltip"
                    :maxlength="50"
                    required
                    :resizable="false"
                    :size
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import DsRadio from '@ds/form/input/DsRadio.vue';
import DsTextarea from '@ds/form/input/text/DsTextarea.vue';
import type { DsInputSize } from '@ds/form/input/text/text-input.types';
import { ref } from 'vue';

const size = ref<DsInputSize>('md');

const basicValue = ref('Textarea sample');
const helperTextValue = ref('Textarea sample');
const requiredValue = ref('Textarea sample');
const infoIconValue = ref('Textarea sample');
const customRowsValue = ref('Textarea sample');
const nonResizableValue = ref('Textarea sample');
const errorValue = ref('Textarea sample');
const errorWithoutMessageValue = ref('Textarea sample');
const characterLimitValue = ref('');
const nonResizableCharacterLimitValue = ref('');
</script>
